import { SuccessMessageEvent } from "../../../../js/lib/components/SuccessMessage";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";

/**
 * @deprecated
 */
export const SuccessMessageControl = (function () {

  return {
    show: function (message) {
      TLCEventManager.fireEvent(SuccessMessageEvent, {message});
    }
  };
})();
